var map = {
	"./Last_page.png": "./src/EGRContent/Story/BadarkoGhar/images/Last_page.png",
	"./bg03.png": "./src/EGRContent/Story/BadarkoGhar/images/bg03.png",
	"./bg_01.png": "./src/EGRContent/Story/BadarkoGhar/images/bg_01.png",
	"./bg_02.png": "./src/EGRContent/Story/BadarkoGhar/images/bg_02.png",
	"./cover_banner.png": "./src/EGRContent/Story/BadarkoGhar/images/cover_banner.png",
	"./cover_page.gif": "./src/EGRContent/Story/BadarkoGhar/images/cover_page.gif",
	"./eight_-monkeys.png": "./src/EGRContent/Story/BadarkoGhar/images/eight_-monkeys.png",
	"./eight_monkeys.gif": "./src/EGRContent/Story/BadarkoGhar/images/eight_monkeys.gif",
	"./final-scene-all-of-them-are-at-home.gif": "./src/EGRContent/Story/BadarkoGhar/images/final-scene-all-of-them-are-at-home.gif",
	"./final-scene-all-of-them-are-at-home.png": "./src/EGRContent/Story/BadarkoGhar/images/final-scene-all-of-them-are-at-home.png",
	"./five_monkey.gif": "./src/EGRContent/Story/BadarkoGhar/images/five_monkey.gif",
	"./five_monkey.png": "./src/EGRContent/Story/BadarkoGhar/images/five_monkey.png",
	"./four_monkeys.gif": "./src/EGRContent/Story/BadarkoGhar/images/four_monkeys.gif",
	"./four_monkeys.png": "./src/EGRContent/Story/BadarkoGhar/images/four_monkeys.png",
	"./nine_monkeys.gif": "./src/EGRContent/Story/BadarkoGhar/images/nine_monkeys.gif",
	"./nine_monkeys.png": "./src/EGRContent/Story/BadarkoGhar/images/nine_monkeys.png",
	"./one_monkey_walk.gif": "./src/EGRContent/Story/BadarkoGhar/images/one_monkey_walk.gif",
	"./one_monkey_walk.png": "./src/EGRContent/Story/BadarkoGhar/images/one_monkey_walk.png",
	"./seven_monkeys.gif": "./src/EGRContent/Story/BadarkoGhar/images/seven_monkeys.gif",
	"./seven_monkeys.png": "./src/EGRContent/Story/BadarkoGhar/images/seven_monkeys.png",
	"./six_-monkeys.png": "./src/EGRContent/Story/BadarkoGhar/images/six_-monkeys.png",
	"./six_monkeys.gif": "./src/EGRContent/Story/BadarkoGhar/images/six_monkeys.gif",
	"./story-banner.svg": "./src/EGRContent/Story/BadarkoGhar/images/story-banner.svg",
	"./ten_-monkeys.png": "./src/EGRContent/Story/BadarkoGhar/images/ten_-monkeys.png",
	"./ten_monkeys.gif": "./src/EGRContent/Story/BadarkoGhar/images/ten_monkeys.gif",
	"./ten_monkeys_kitchen.gif": "./src/EGRContent/Story/BadarkoGhar/images/ten_monkeys_kitchen.gif",
	"./ten_monkeys_kitchen.png": "./src/EGRContent/Story/BadarkoGhar/images/ten_monkeys_kitchen.png",
	"./three_droppingdown.png": "./src/EGRContent/Story/BadarkoGhar/images/three_droppingdown.png",
	"./three_monkey_P4.png": "./src/EGRContent/Story/BadarkoGhar/images/three_monkey_P4.png",
	"./three_monkey_lift_wood.gif": "./src/EGRContent/Story/BadarkoGhar/images/three_monkey_lift_wood.gif",
	"./three_monkey_lift_wood.png": "./src/EGRContent/Story/BadarkoGhar/images/three_monkey_lift_wood.png",
	"./twelve_monkeys_kitchen.gif": "./src/EGRContent/Story/BadarkoGhar/images/twelve_monkeys_kitchen.gif",
	"./twelve_monkeys_kitchen.png": "./src/EGRContent/Story/BadarkoGhar/images/twelve_monkeys_kitchen.png",
	"./two_droppingdown01.png": "./src/EGRContent/Story/BadarkoGhar/images/two_droppingdown01.png",
	"./two_monkey.png": "./src/EGRContent/Story/BadarkoGhar/images/two_monkey.png",
	"./two_monkey_cuttingwood.gif": "./src/EGRContent/Story/BadarkoGhar/images/two_monkey_cuttingwood.gif",
	"./two_monkey_cuttingwood.png": "./src/EGRContent/Story/BadarkoGhar/images/two_monkey_cuttingwood.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/BadarkoGhar/images sync recursive ^\\.\\/.*$";